import type { GameSessionController } from '../session/types.js';

const activeSessions = new Set<GameSessionController>();

export function registerActiveSession(session: GameSessionController): () => void {
  activeSessions.add(session);
  return () => {
    activeSessions.delete(session);
  };
}

export async function saveAllActiveSessions(): Promise<void> {
  await Promise.all([...activeSessions].map((session) => session.saveNow()));
}

export function getActiveSessionCount(): number {
  return activeSessions.size;
}
